var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._m(0),_c('div',{staticClass:"title"},[_vm._v("支付成功")]),_c('router-link',{staticClass:"btn",attrs:{"to":{path: '/'}}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon img-cover"},[_c('img',{attrs:{"src":require("../../assets/images/success-icon.png")}})])
}]

export { render, staticRenderFns }